import React, { FC } from 'react';

import { IconProps } from '../../shared/ui';

export const LogoVideoCallIcon: FC<IconProps> = ({ width = 172, height = 50, fill = '#fff', className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 1729.12 450"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="1729.12" height="450" rx="12" fill="#585858" fillOpacity="0.3" />

      <polygon
        fill="white"
        fillOpacity="0.4"
        points="325.75 72.75 183.72 308.88 310.29 308.88 310.29 374.26 52.3 374.26 194.99 138.13 76.37 138.13 76.37 72.75 325.75 72.75"
      />
      <path
        fill="white"
        fillOpacity="0.4"
        d="M429.13,374.26h-72.67V169.28h72.67v204.98Zm4.42-283.73c0,11.45-3.94,21.11-11.78,28.97-7.88,7.86-17.52,11.78-28.97,11.78s-20.91-3.96-28.75-11.89c-7.88-7.93-11.78-17.56-11.78-28.86s3.9-20.89,11.78-28.75c7.84-7.84,17.45-11.78,28.75-11.78s20.91,3.94,28.86,11.78c7.92,7.86,11.89,17.45,11.89,28.75"
      />
      <polygon
        fill="white"
        fillOpacity="0.4"
        points="786.52 374.26 708.11 374.26 563.87 189.6 563.87 374.26 485.45 374.26 485.45 72.75 563.87 72.75 708.11 257.19 708.11 72.75 786.52 72.75 786.52 374.26"
      />
      <path
        fill="white"
        fillOpacity="0.4"
        d="M1151.87,206.83c0,32.69-3.68,59.35-11.04,79.96-11.19,31.37-29.67,55.52-55.44,72.45-24.89,16.2-54.34,24.3-88.35,24.3-55.37,0-97.85-18.85-127.45-56.55-22.38-28.57-33.58-62.66-33.58-102.27,0-43.88,13.11-80.77,39.32-110.66,29.75-34.02,71.27-51.02,124.58-51.02,35.64,0,65.82,9.13,90.56,27.39,17.67,12.96,32.76,32.1,45.28,57.43l-74.22,30.7c-6.37-14.06-13.73-24.63-22.16-31.66-12.11-9.96-26.51-14.95-43.22-14.95-34.09,0-57.91,17.56-71.35,52.68-5.01,12.92-7.51,26.29-7.51,40.09,0,28.64,9.09,52.53,27.24,71.6,13.44,14.25,31.4,21.39,53.86,21.39,19.92,0,35.71-5.78,47.42-17.38,7.66-7.62,12.7-18.92,15.06-33.87h-64.5v-59.64h155.5Z"
      />
      <path
        fill="white"
        fillOpacity="0.4"
        d="M1267.17,374.26h-72.67V169.28h72.67v204.98Zm4.42-283.73c0,11.45-3.94,21.11-11.78,28.97-7.88,7.86-17.52,11.78-28.97,11.78s-20.91-3.96-28.75-11.89c-7.88-7.93-11.78-17.56-11.78-28.86s3.9-20.89,11.78-28.75c7.84-7.84,17.45-11.78,28.75-11.78s20.91,3.94,28.86,11.78c7.92,7.86,11.89,17.45,11.89,28.75"
      />
      <polygon
        fill="white"
        fillOpacity="0.4"
        points="1571.33 72.75 1429.3 308.88 1555.87 308.88 1555.87 374.26 1297.87 374.26 1440.56 138.13 1321.95 138.13 1321.95 72.75 1571.33 72.75"
      />
      <path
        fill="white"
        fillOpacity="0.4"
        d="M1674.7,374.26h-72.67V169.28h72.67v204.98Zm4.42-283.73c0,11.45-3.94,21.11-11.78,28.97-7.88,7.86-17.52,11.78-28.97,11.78s-20.91-3.96-28.75-11.89c-7.88-7.93-11.78-17.56-11.78-28.86s3.9-20.89,11.78-28.75c7.84-7.84,17.45-11.78,28.75-11.78s20.91,3.94,28.86,11.78c7.92,7.86,11.89,17.45,11.89,28.75"
      />
    </svg>
  );
};
